export default {
  TRANSLATE_LANGUAGE: 'TRANSLATE_LANGUAGE',
  IS_CHUNK_AGGREGATED_RESPONSE: 'IS_CHUNK_AGGREGATED_RESPONSE'
}
